import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ek{background:var(--palette-white);}.ssr-plugin'
import '.ap{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ab{max-width:77.5rem;}.ssr-plugin'
import '.fw{justify-content:stretch;}.ssr-plugin'
import '.bm{position:sticky;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.br{z-index:10;}.ssr-plugin'
import '.fx{padding-block:1rem;}.ssr-plugin'
import '.fy{height:3rem;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.ah{flex-wrap:wrap;}.ssr-plugin'
import '.g0{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fd{margin-top:2rem;}.ssr-plugin'
import '.gl{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const CreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d r at e ek"
      >
        <div className="ap d t at e"
        >
          <div className="n ab d e fw bm bn br"
            style={{
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            <nav className="fx fy d ae t ah"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="g0 d e r fd gl n ab"
            style={{
              gap: gap, // 8rem is padding + navbar height
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
